module.exports = __webpack_public_path__ + "static/img/HY-S1-II-device.902e5cbc.png";